module.exports = __webpack_public_path__ + "static/worth-dying-for-9f3980ccdbf18716d26c6becbbe5bf0c.jpg";